/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivateFreeUnlockOfferBody } from '../models';
// @ts-ignore
import type { AdminAddCreditsBody } from '../models';
// @ts-ignore
import type { ChangeFreeUnlockOfferInvitesResponse } from '../models';
// @ts-ignore
import type { ClaimFreeUnlockOfferLinkBody } from '../models';
// @ts-ignore
import type { EmployerCreditOverviewResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FreeUnlockOfferBody } from '../models';
// @ts-ignore
import type { FreeUnlockOfferInvitesBody } from '../models';
// @ts-ignore
import type { FreeUnlockOfferSub } from '../models';
// @ts-ignore
import type { GetCreditHistoryResponse } from '../models';
// @ts-ignore
import type { GetCreditPacksResponse } from '../models';
// @ts-ignore
import type { GetFreeUnlockOfferAudienceResponse } from '../models';
// @ts-ignore
import type { GetFreeUnlockOfferEmailReachResponse } from '../models';
// @ts-ignore
import type { GetFreeUnlockOfferInvitesResponse } from '../models';
// @ts-ignore
import type { GetFreeUnlockOffersResponse } from '../models';
// @ts-ignore
import type { GetUnlockedCandidatesResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UnlockApplicantResponse } from '../models';
/**
 * EmployerCreditApiApi - axios parameter creator
 */
export const EmployerCreditApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {ActivateFreeUnlockOfferBody} activateFreeUnlockOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiActivateFreeUnlockOffer: async (orgId: string, activateFreeUnlockOfferBody: ActivateFreeUnlockOfferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiActivateFreeUnlockOffer', 'orgId', orgId)
            // verify required parameter 'activateFreeUnlockOfferBody' is not null or undefined
            assertParamExists('employerCreditApiActivateFreeUnlockOffer', 'activateFreeUnlockOfferBody', activateFreeUnlockOfferBody)
            const localVarPath = `/org/{org_id}/credits/free-unlock-offer/activate`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateFreeUnlockOfferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {FreeUnlockOfferInvitesBody} freeUnlockOfferInvitesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiAddFreeUnlockOfferInvites: async (offerId: string, freeUnlockOfferInvitesBody: FreeUnlockOfferInvitesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('employerCreditApiAddFreeUnlockOfferInvites', 'offerId', offerId)
            // verify required parameter 'freeUnlockOfferInvitesBody' is not null or undefined
            assertParamExists('employerCreditApiAddFreeUnlockOfferInvites', 'freeUnlockOfferInvitesBody', freeUnlockOfferInvitesBody)
            const localVarPath = `/admin/free-unlock-offers/{offer_id}/invites`
                .replace('{offer_id}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeUnlockOfferInvitesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AdminAddCreditsBody} adminAddCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiAdminAddEmployerCredits: async (orgId: string, adminAddCreditsBody: AdminAddCreditsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiAdminAddEmployerCredits', 'orgId', orgId)
            // verify required parameter 'adminAddCreditsBody' is not null or undefined
            assertParamExists('employerCreditApiAdminAddEmployerCredits', 'adminAddCreditsBody', adminAddCreditsBody)
            const localVarPath = `/admin/org/{org_id}/credits`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddCreditsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {ClaimFreeUnlockOfferLinkBody} claimFreeUnlockOfferLinkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiClaimFreeUnlockOfferLink: async (orgId: string, claimFreeUnlockOfferLinkBody: ClaimFreeUnlockOfferLinkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiClaimFreeUnlockOfferLink', 'orgId', orgId)
            // verify required parameter 'claimFreeUnlockOfferLinkBody' is not null or undefined
            assertParamExists('employerCreditApiClaimFreeUnlockOfferLink', 'claimFreeUnlockOfferLinkBody', claimFreeUnlockOfferLinkBody)
            const localVarPath = `/org/{org_id}/credits/free-unlock-offer/claim`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimFreeUnlockOfferLinkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FreeUnlockOfferBody} freeUnlockOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiCreateFreeUnlockOffer: async (freeUnlockOfferBody: FreeUnlockOfferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'freeUnlockOfferBody' is not null or undefined
            assertParamExists('employerCreditApiCreateFreeUnlockOffer', 'freeUnlockOfferBody', freeUnlockOfferBody)
            const localVarPath = `/admin/free-unlock-offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeUnlockOfferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiDeleteFreeUnlockOffer: async (offerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('employerCreditApiDeleteFreeUnlockOffer', 'offerId', offerId)
            const localVarPath = `/admin/free-unlock-offers/{offer_id}`
                .replace('{offer_id}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiEndFreeUnlockOffer: async (offerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('employerCreditApiEndFreeUnlockOffer', 'offerId', offerId)
            const localVarPath = `/admin/free-unlock-offers/{offer_id}/end`
                .replace('{offer_id}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetEmployerCreditHistory: async (orgId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiGetEmployerCreditHistory', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/credits/history`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [platform] 
         * @param {boolean | null} [showAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetEmployerCreditPacks: async (platform?: string | null, showAll?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credits/packs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (showAll !== undefined) {
                localVarQueryParameter['show_all'] = showAll;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetEmployerCredits: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiGetEmployerCredits', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/credits`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum} [audience] 
         * @param {number} [createdWithinDays] 
         * @param {number} [minApplications] 
         * @param {number} [minJobs] 
         * @param {string | null} [offerId] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetFreeUnlockOfferAudience: async (audience?: EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum, createdWithinDays?: number, minApplications?: number, minJobs?: number, offerId?: string | null, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/free-unlock-offer/audience`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (audience !== undefined) {
                localVarQueryParameter['audience'] = audience;
            }

            if (createdWithinDays !== undefined) {
                localVarQueryParameter['created_within_days'] = createdWithinDays;
            }

            if (minApplications !== undefined) {
                localVarQueryParameter['min_applications'] = minApplications;
            }

            if (minJobs !== undefined) {
                localVarQueryParameter['min_jobs'] = minJobs;
            }

            if (offerId !== undefined) {
                localVarQueryParameter['offer_id'] = offerId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum} [audience] 
         * @param {number} [createdWithinDays] 
         * @param {boolean} [emailProspects] 
         * @param {number} [employerEmailLimit] 
         * @param {string | null} [endDate] 
         * @param {number} [minApplications] 
         * @param {number} [minJobs] 
         * @param {string | null} [offerId] 
         * @param {number} [prospectAddedWithinDays] 
         * @param {number} [prospectEmailLimit] 
         * @param {Array<string>} [prospectJobRoleCategories] 
         * @param {number} [prospectPostedWithinDays] 
         * @param {Array<string>} [prospectSources] 
         * @param {boolean} [sendEmails] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetFreeUnlockOfferEmailReach: async (audience?: EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum, createdWithinDays?: number, emailProspects?: boolean, employerEmailLimit?: number, endDate?: string | null, minApplications?: number, minJobs?: number, offerId?: string | null, prospectAddedWithinDays?: number, prospectEmailLimit?: number, prospectJobRoleCategories?: Array<string>, prospectPostedWithinDays?: number, prospectSources?: Array<string>, sendEmails?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/free-unlock-offer/email-reach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (audience !== undefined) {
                localVarQueryParameter['audience'] = audience;
            }

            if (createdWithinDays !== undefined) {
                localVarQueryParameter['created_within_days'] = createdWithinDays;
            }

            if (emailProspects !== undefined) {
                localVarQueryParameter['email_prospects'] = emailProspects;
            }

            if (employerEmailLimit !== undefined) {
                localVarQueryParameter['employer_email_limit'] = employerEmailLimit;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (minApplications !== undefined) {
                localVarQueryParameter['min_applications'] = minApplications;
            }

            if (minJobs !== undefined) {
                localVarQueryParameter['min_jobs'] = minJobs;
            }

            if (offerId !== undefined) {
                localVarQueryParameter['offer_id'] = offerId;
            }

            if (prospectAddedWithinDays !== undefined) {
                localVarQueryParameter['prospect_added_within_days'] = prospectAddedWithinDays;
            }

            if (prospectEmailLimit !== undefined) {
                localVarQueryParameter['prospect_email_limit'] = prospectEmailLimit;
            }

            if (prospectJobRoleCategories) {
                localVarQueryParameter['prospect_job_role_categories'] = prospectJobRoleCategories;
            }

            if (prospectPostedWithinDays !== undefined) {
                localVarQueryParameter['prospect_posted_within_days'] = prospectPostedWithinDays;
            }

            if (prospectSources) {
                localVarQueryParameter['prospect_sources'] = prospectSources;
            }

            if (sendEmails !== undefined) {
                localVarQueryParameter['send_emails'] = sendEmails;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetFreeUnlockOfferInvites: async (offerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('employerCreditApiGetFreeUnlockOfferInvites', 'offerId', offerId)
            const localVarPath = `/admin/free-unlock-offers/{offer_id}/invites`
                .replace('{offer_id}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetUnlockedCandidates: async (orgId: string, jobId?: string | null, page?: number, pageSize?: number, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiGetUnlockedCandidates', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/unlocked-candidates`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiListFreeUnlockOffers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/free-unlock-offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {FreeUnlockOfferInvitesBody} freeUnlockOfferInvitesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiRemoveFreeUnlockOfferInvites: async (offerId: string, freeUnlockOfferInvitesBody: FreeUnlockOfferInvitesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('employerCreditApiRemoveFreeUnlockOfferInvites', 'offerId', offerId)
            // verify required parameter 'freeUnlockOfferInvitesBody' is not null or undefined
            assertParamExists('employerCreditApiRemoveFreeUnlockOfferInvites', 'freeUnlockOfferInvitesBody', freeUnlockOfferInvitesBody)
            const localVarPath = `/admin/free-unlock-offers/{offer_id}/invites/remove`
                .replace('{offer_id}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeUnlockOfferInvitesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiUnlockApplicant: async (applicantId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('employerCreditApiUnlockApplicant', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('employerCreditApiUnlockApplicant', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('employerCreditApiUnlockApplicant', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/unlock`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offerId 
         * @param {FreeUnlockOfferBody} freeUnlockOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiUpdateFreeUnlockOffer: async (offerId: string, freeUnlockOfferBody: FreeUnlockOfferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('employerCreditApiUpdateFreeUnlockOffer', 'offerId', offerId)
            // verify required parameter 'freeUnlockOfferBody' is not null or undefined
            assertParamExists('employerCreditApiUpdateFreeUnlockOffer', 'freeUnlockOfferBody', freeUnlockOfferBody)
            const localVarPath = `/admin/free-unlock-offers/{offer_id}`
                .replace('{offer_id}', encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeUnlockOfferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployerCreditApiApi - functional programming interface
 */
export const EmployerCreditApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployerCreditApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {ActivateFreeUnlockOfferBody} activateFreeUnlockOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiActivateFreeUnlockOffer(orgId: string, activateFreeUnlockOfferBody: ActivateFreeUnlockOfferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerCreditOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiActivateFreeUnlockOffer(orgId, activateFreeUnlockOfferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiActivateFreeUnlockOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {FreeUnlockOfferInvitesBody} freeUnlockOfferInvitesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiAddFreeUnlockOfferInvites(offerId: string, freeUnlockOfferInvitesBody: FreeUnlockOfferInvitesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeFreeUnlockOfferInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiAddFreeUnlockOfferInvites(offerId, freeUnlockOfferInvitesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiAddFreeUnlockOfferInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AdminAddCreditsBody} adminAddCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiAdminAddEmployerCredits(orgId: string, adminAddCreditsBody: AdminAddCreditsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerCreditOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiAdminAddEmployerCredits(orgId, adminAddCreditsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiAdminAddEmployerCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {ClaimFreeUnlockOfferLinkBody} claimFreeUnlockOfferLinkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiClaimFreeUnlockOfferLink(orgId: string, claimFreeUnlockOfferLinkBody: ClaimFreeUnlockOfferLinkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerCreditOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiClaimFreeUnlockOfferLink(orgId, claimFreeUnlockOfferLinkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiClaimFreeUnlockOfferLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FreeUnlockOfferBody} freeUnlockOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiCreateFreeUnlockOffer(freeUnlockOfferBody: FreeUnlockOfferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeUnlockOfferSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiCreateFreeUnlockOffer(freeUnlockOfferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiCreateFreeUnlockOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiDeleteFreeUnlockOffer(offerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiDeleteFreeUnlockOffer(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiDeleteFreeUnlockOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiEndFreeUnlockOffer(offerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeUnlockOfferSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiEndFreeUnlockOffer(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiEndFreeUnlockOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetEmployerCreditHistory(orgId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCreditHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetEmployerCreditHistory(orgId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetEmployerCreditHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [platform] 
         * @param {boolean | null} [showAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetEmployerCreditPacks(platform?: string | null, showAll?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCreditPacksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetEmployerCreditPacks(platform, showAll, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetEmployerCreditPacks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetEmployerCredits(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerCreditOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetEmployerCredits(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetEmployerCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum} [audience] 
         * @param {number} [createdWithinDays] 
         * @param {number} [minApplications] 
         * @param {number} [minJobs] 
         * @param {string | null} [offerId] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetFreeUnlockOfferAudience(audience?: EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum, createdWithinDays?: number, minApplications?: number, minJobs?: number, offerId?: string | null, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeUnlockOfferAudienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetFreeUnlockOfferAudience(audience, createdWithinDays, minApplications, minJobs, offerId, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetFreeUnlockOfferAudience']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum} [audience] 
         * @param {number} [createdWithinDays] 
         * @param {boolean} [emailProspects] 
         * @param {number} [employerEmailLimit] 
         * @param {string | null} [endDate] 
         * @param {number} [minApplications] 
         * @param {number} [minJobs] 
         * @param {string | null} [offerId] 
         * @param {number} [prospectAddedWithinDays] 
         * @param {number} [prospectEmailLimit] 
         * @param {Array<string>} [prospectJobRoleCategories] 
         * @param {number} [prospectPostedWithinDays] 
         * @param {Array<string>} [prospectSources] 
         * @param {boolean} [sendEmails] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetFreeUnlockOfferEmailReach(audience?: EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum, createdWithinDays?: number, emailProspects?: boolean, employerEmailLimit?: number, endDate?: string | null, minApplications?: number, minJobs?: number, offerId?: string | null, prospectAddedWithinDays?: number, prospectEmailLimit?: number, prospectJobRoleCategories?: Array<string>, prospectPostedWithinDays?: number, prospectSources?: Array<string>, sendEmails?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeUnlockOfferEmailReachResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetFreeUnlockOfferEmailReach(audience, createdWithinDays, emailProspects, employerEmailLimit, endDate, minApplications, minJobs, offerId, prospectAddedWithinDays, prospectEmailLimit, prospectJobRoleCategories, prospectPostedWithinDays, prospectSources, sendEmails, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetFreeUnlockOfferEmailReach']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetFreeUnlockOfferInvites(offerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeUnlockOfferInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetFreeUnlockOfferInvites(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetFreeUnlockOfferInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiGetUnlockedCandidates(orgId: string, jobId?: string | null, page?: number, pageSize?: number, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnlockedCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiGetUnlockedCandidates(orgId, jobId, page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiGetUnlockedCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiListFreeUnlockOffers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeUnlockOffersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiListFreeUnlockOffers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiListFreeUnlockOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {FreeUnlockOfferInvitesBody} freeUnlockOfferInvitesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiRemoveFreeUnlockOfferInvites(offerId: string, freeUnlockOfferInvitesBody: FreeUnlockOfferInvitesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeFreeUnlockOfferInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiRemoveFreeUnlockOfferInvites(offerId, freeUnlockOfferInvitesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiRemoveFreeUnlockOfferInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiUnlockApplicant(applicantId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockApplicantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiUnlockApplicant(applicantId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiUnlockApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} offerId 
         * @param {FreeUnlockOfferBody} freeUnlockOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerCreditApiUpdateFreeUnlockOffer(offerId: string, freeUnlockOfferBody: FreeUnlockOfferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeUnlockOfferSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employerCreditApiUpdateFreeUnlockOffer(offerId, freeUnlockOfferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerCreditApiApi.employerCreditApiUpdateFreeUnlockOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployerCreditApiApi - factory interface
 */
export const EmployerCreditApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployerCreditApiApiFp(configuration)
    return {
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiActivateFreeUnlockOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiActivateFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiActivateFreeUnlockOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployerCreditOverviewResponse> {
            return localVarFp.employerCreditApiActivateFreeUnlockOffer(requestParameters.orgId, requestParameters.activateFreeUnlockOfferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiAddFreeUnlockOfferInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiAddFreeUnlockOfferInvites(requestParameters: EmployerCreditApiApiEmployerCreditApiAddFreeUnlockOfferInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeFreeUnlockOfferInvitesResponse> {
            return localVarFp.employerCreditApiAddFreeUnlockOfferInvites(requestParameters.offerId, requestParameters.freeUnlockOfferInvitesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiAdminAddEmployerCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiAdminAddEmployerCredits(requestParameters: EmployerCreditApiApiEmployerCreditApiAdminAddEmployerCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployerCreditOverviewResponse> {
            return localVarFp.employerCreditApiAdminAddEmployerCredits(requestParameters.orgId, requestParameters.adminAddCreditsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiClaimFreeUnlockOfferLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiClaimFreeUnlockOfferLink(requestParameters: EmployerCreditApiApiEmployerCreditApiClaimFreeUnlockOfferLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployerCreditOverviewResponse> {
            return localVarFp.employerCreditApiClaimFreeUnlockOfferLink(requestParameters.orgId, requestParameters.claimFreeUnlockOfferLinkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiCreateFreeUnlockOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiCreateFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiCreateFreeUnlockOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<FreeUnlockOfferSub> {
            return localVarFp.employerCreditApiCreateFreeUnlockOffer(requestParameters.freeUnlockOfferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiDeleteFreeUnlockOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiDeleteFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiDeleteFreeUnlockOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.employerCreditApiDeleteFreeUnlockOffer(requestParameters.offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiEndFreeUnlockOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiEndFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiEndFreeUnlockOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<FreeUnlockOfferSub> {
            return localVarFp.employerCreditApiEndFreeUnlockOffer(requestParameters.offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetEmployerCreditHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetEmployerCreditHistory(requestParameters: EmployerCreditApiApiEmployerCreditApiGetEmployerCreditHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCreditHistoryResponse> {
            return localVarFp.employerCreditApiGetEmployerCreditHistory(requestParameters.orgId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetEmployerCreditPacksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetEmployerCreditPacks(requestParameters: EmployerCreditApiApiEmployerCreditApiGetEmployerCreditPacksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCreditPacksResponse> {
            return localVarFp.employerCreditApiGetEmployerCreditPacks(requestParameters.platform, requestParameters.showAll, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetEmployerCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetEmployerCredits(requestParameters: EmployerCreditApiApiEmployerCreditApiGetEmployerCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployerCreditOverviewResponse> {
            return localVarFp.employerCreditApiGetEmployerCredits(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetFreeUnlockOfferAudience(requestParameters: EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferAudienceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFreeUnlockOfferAudienceResponse> {
            return localVarFp.employerCreditApiGetFreeUnlockOfferAudience(requestParameters.audience, requestParameters.createdWithinDays, requestParameters.minApplications, requestParameters.minJobs, requestParameters.offerId, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferEmailReachRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetFreeUnlockOfferEmailReach(requestParameters: EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferEmailReachRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFreeUnlockOfferEmailReachResponse> {
            return localVarFp.employerCreditApiGetFreeUnlockOfferEmailReach(requestParameters.audience, requestParameters.createdWithinDays, requestParameters.emailProspects, requestParameters.employerEmailLimit, requestParameters.endDate, requestParameters.minApplications, requestParameters.minJobs, requestParameters.offerId, requestParameters.prospectAddedWithinDays, requestParameters.prospectEmailLimit, requestParameters.prospectJobRoleCategories, requestParameters.prospectPostedWithinDays, requestParameters.prospectSources, requestParameters.sendEmails, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetFreeUnlockOfferInvites(requestParameters: EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFreeUnlockOfferInvitesResponse> {
            return localVarFp.employerCreditApiGetFreeUnlockOfferInvites(requestParameters.offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiGetUnlockedCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiGetUnlockedCandidates(requestParameters: EmployerCreditApiApiEmployerCreditApiGetUnlockedCandidatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUnlockedCandidatesResponse> {
            return localVarFp.employerCreditApiGetUnlockedCandidates(requestParameters.orgId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiListFreeUnlockOffers(options?: RawAxiosRequestConfig): AxiosPromise<GetFreeUnlockOffersResponse> {
            return localVarFp.employerCreditApiListFreeUnlockOffers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiRemoveFreeUnlockOfferInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiRemoveFreeUnlockOfferInvites(requestParameters: EmployerCreditApiApiEmployerCreditApiRemoveFreeUnlockOfferInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeFreeUnlockOfferInvitesResponse> {
            return localVarFp.employerCreditApiRemoveFreeUnlockOfferInvites(requestParameters.offerId, requestParameters.freeUnlockOfferInvitesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiUnlockApplicantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiUnlockApplicant(requestParameters: EmployerCreditApiApiEmployerCreditApiUnlockApplicantRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnlockApplicantResponse> {
            return localVarFp.employerCreditApiUnlockApplicant(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployerCreditApiApiEmployerCreditApiUpdateFreeUnlockOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerCreditApiUpdateFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiUpdateFreeUnlockOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<FreeUnlockOfferSub> {
            return localVarFp.employerCreditApiUpdateFreeUnlockOffer(requestParameters.offerId, requestParameters.freeUnlockOfferBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for employerCreditApiActivateFreeUnlockOffer operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiActivateFreeUnlockOfferRequest {
    readonly orgId: string

    readonly activateFreeUnlockOfferBody: ActivateFreeUnlockOfferBody
}

/**
 * Request parameters for employerCreditApiAddFreeUnlockOfferInvites operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiAddFreeUnlockOfferInvitesRequest {
    readonly offerId: string

    readonly freeUnlockOfferInvitesBody: FreeUnlockOfferInvitesBody
}

/**
 * Request parameters for employerCreditApiAdminAddEmployerCredits operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiAdminAddEmployerCreditsRequest {
    readonly orgId: string

    readonly adminAddCreditsBody: AdminAddCreditsBody
}

/**
 * Request parameters for employerCreditApiClaimFreeUnlockOfferLink operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiClaimFreeUnlockOfferLinkRequest {
    readonly orgId: string

    readonly claimFreeUnlockOfferLinkBody: ClaimFreeUnlockOfferLinkBody
}

/**
 * Request parameters for employerCreditApiCreateFreeUnlockOffer operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiCreateFreeUnlockOfferRequest {
    readonly freeUnlockOfferBody: FreeUnlockOfferBody
}

/**
 * Request parameters for employerCreditApiDeleteFreeUnlockOffer operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiDeleteFreeUnlockOfferRequest {
    readonly offerId: string
}

/**
 * Request parameters for employerCreditApiEndFreeUnlockOffer operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiEndFreeUnlockOfferRequest {
    readonly offerId: string
}

/**
 * Request parameters for employerCreditApiGetEmployerCreditHistory operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetEmployerCreditHistoryRequest {
    readonly orgId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for employerCreditApiGetEmployerCreditPacks operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetEmployerCreditPacksRequest {
    readonly platform?: string | null

    readonly showAll?: boolean | null
}

/**
 * Request parameters for employerCreditApiGetEmployerCredits operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetEmployerCreditsRequest {
    readonly orgId: string
}

/**
 * Request parameters for employerCreditApiGetFreeUnlockOfferAudience operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferAudienceRequest {
    readonly audience?: EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum

    readonly createdWithinDays?: number

    readonly minApplications?: number

    readonly minJobs?: number

    readonly offerId?: string | null

    readonly startDate?: string | null
}

/**
 * Request parameters for employerCreditApiGetFreeUnlockOfferEmailReach operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferEmailReachRequest {
    readonly audience?: EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum

    readonly createdWithinDays?: number

    readonly emailProspects?: boolean

    readonly employerEmailLimit?: number

    readonly endDate?: string | null

    readonly minApplications?: number

    readonly minJobs?: number

    readonly offerId?: string | null

    readonly prospectAddedWithinDays?: number

    readonly prospectEmailLimit?: number

    readonly prospectJobRoleCategories?: Array<string>

    readonly prospectPostedWithinDays?: number

    readonly prospectSources?: Array<string>

    readonly sendEmails?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for employerCreditApiGetFreeUnlockOfferInvites operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferInvitesRequest {
    readonly offerId: string
}

/**
 * Request parameters for employerCreditApiGetUnlockedCandidates operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiGetUnlockedCandidatesRequest {
    readonly orgId: string

    readonly jobId?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null
}

/**
 * Request parameters for employerCreditApiRemoveFreeUnlockOfferInvites operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiRemoveFreeUnlockOfferInvitesRequest {
    readonly offerId: string

    readonly freeUnlockOfferInvitesBody: FreeUnlockOfferInvitesBody
}

/**
 * Request parameters for employerCreditApiUnlockApplicant operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiUnlockApplicantRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for employerCreditApiUpdateFreeUnlockOffer operation in EmployerCreditApiApi.
 */
export interface EmployerCreditApiApiEmployerCreditApiUpdateFreeUnlockOfferRequest {
    readonly offerId: string

    readonly freeUnlockOfferBody: FreeUnlockOfferBody
}

/**
 * EmployerCreditApiApi - object-oriented interface
 */
export class EmployerCreditApiApi extends BaseAPI {
    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiActivateFreeUnlockOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiActivateFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiActivateFreeUnlockOfferRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiActivateFreeUnlockOffer(requestParameters.orgId, requestParameters.activateFreeUnlockOfferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiAddFreeUnlockOfferInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiAddFreeUnlockOfferInvites(requestParameters: EmployerCreditApiApiEmployerCreditApiAddFreeUnlockOfferInvitesRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiAddFreeUnlockOfferInvites(requestParameters.offerId, requestParameters.freeUnlockOfferInvitesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiAdminAddEmployerCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiAdminAddEmployerCredits(requestParameters: EmployerCreditApiApiEmployerCreditApiAdminAddEmployerCreditsRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiAdminAddEmployerCredits(requestParameters.orgId, requestParameters.adminAddCreditsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiClaimFreeUnlockOfferLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiClaimFreeUnlockOfferLink(requestParameters: EmployerCreditApiApiEmployerCreditApiClaimFreeUnlockOfferLinkRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiClaimFreeUnlockOfferLink(requestParameters.orgId, requestParameters.claimFreeUnlockOfferLinkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiCreateFreeUnlockOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiCreateFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiCreateFreeUnlockOfferRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiCreateFreeUnlockOffer(requestParameters.freeUnlockOfferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiDeleteFreeUnlockOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiDeleteFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiDeleteFreeUnlockOfferRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiDeleteFreeUnlockOffer(requestParameters.offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiEndFreeUnlockOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiEndFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiEndFreeUnlockOfferRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiEndFreeUnlockOffer(requestParameters.offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetEmployerCreditHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetEmployerCreditHistory(requestParameters: EmployerCreditApiApiEmployerCreditApiGetEmployerCreditHistoryRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetEmployerCreditHistory(requestParameters.orgId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetEmployerCreditPacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetEmployerCreditPacks(requestParameters: EmployerCreditApiApiEmployerCreditApiGetEmployerCreditPacksRequest = {}, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetEmployerCreditPacks(requestParameters.platform, requestParameters.showAll, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetEmployerCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetEmployerCredits(requestParameters: EmployerCreditApiApiEmployerCreditApiGetEmployerCreditsRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetEmployerCredits(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetFreeUnlockOfferAudience(requestParameters: EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferAudienceRequest = {}, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetFreeUnlockOfferAudience(requestParameters.audience, requestParameters.createdWithinDays, requestParameters.minApplications, requestParameters.minJobs, requestParameters.offerId, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferEmailReachRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetFreeUnlockOfferEmailReach(requestParameters: EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferEmailReachRequest = {}, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetFreeUnlockOfferEmailReach(requestParameters.audience, requestParameters.createdWithinDays, requestParameters.emailProspects, requestParameters.employerEmailLimit, requestParameters.endDate, requestParameters.minApplications, requestParameters.minJobs, requestParameters.offerId, requestParameters.prospectAddedWithinDays, requestParameters.prospectEmailLimit, requestParameters.prospectJobRoleCategories, requestParameters.prospectPostedWithinDays, requestParameters.prospectSources, requestParameters.sendEmails, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetFreeUnlockOfferInvites(requestParameters: EmployerCreditApiApiEmployerCreditApiGetFreeUnlockOfferInvitesRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetFreeUnlockOfferInvites(requestParameters.offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiGetUnlockedCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiGetUnlockedCandidates(requestParameters: EmployerCreditApiApiEmployerCreditApiGetUnlockedCandidatesRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiGetUnlockedCandidates(requestParameters.orgId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiListFreeUnlockOffers(options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiListFreeUnlockOffers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiRemoveFreeUnlockOfferInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiRemoveFreeUnlockOfferInvites(requestParameters: EmployerCreditApiApiEmployerCreditApiRemoveFreeUnlockOfferInvitesRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiRemoveFreeUnlockOfferInvites(requestParameters.offerId, requestParameters.freeUnlockOfferInvitesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiUnlockApplicantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiUnlockApplicant(requestParameters: EmployerCreditApiApiEmployerCreditApiUnlockApplicantRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiUnlockApplicant(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployerCreditApiApiEmployerCreditApiUpdateFreeUnlockOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employerCreditApiUpdateFreeUnlockOffer(requestParameters: EmployerCreditApiApiEmployerCreditApiUpdateFreeUnlockOfferRequest, options?: RawAxiosRequestConfig) {
        return EmployerCreditApiApiFp(this.configuration).employerCreditApiUpdateFreeUnlockOffer(requestParameters.offerId, requestParameters.freeUnlockOfferBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum = {
    Invited: 'invited',
    All: 'all',
    Rules: 'rules',
} as const;
export type EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum = typeof EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum[keyof typeof EmployerCreditApiGetFreeUnlockOfferAudienceAudienceEnum];
export const EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum = {
    Invited: 'invited',
    All: 'all',
    Rules: 'rules',
} as const;
export type EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum = typeof EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum[keyof typeof EmployerCreditApiGetFreeUnlockOfferEmailReachAudienceEnum];
